export default __webpack_public_path__ + "static/media/dg-title-cn.e49903cb.webp";